//payload_Key
export const MC_NEW_POPUP_MSG = 'MC_NEW_POPUP_MSG';
export const MC_NEW_POPUP_MSG_REST = 'MC_NEW_POPUP_MSG_REST';

//store state
const initialState = {
  popNum: 0,
  hasNewMsg: false,
};

export function updatePopNum() {
  return {
    type: MC_NEW_POPUP_MSG,
    payload: 1,
  };
}

export function resetHasNewMsg() {
  return {
    type: MC_NEW_POPUP_MSG_REST,
  };
}

//reducer
export default function mcNewPopupMsg(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MC_NEW_POPUP_MSG: {
      return { ...state, popNum: state?.popNum + payload, hasNewMsg: true };
    }
    case MC_NEW_POPUP_MSG_REST: {
      return { ...state, hasNewMsg: false };
    }
    default: {
      return { ...state };
    }
  }
}
